module.exports = __webpack_public_path__ + "img/5.3da23b17.png";